var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "5579e7a3df1c79ea17dfdc2ad1b4eae83a1c21f8"
};